import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPixivComponent } from './simple-icons-pixiv.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPixivComponent ],
    exports:      [ SimpleIconsPixivComponent ],
    bootstrap:    []
})
export class SimpleIconsPixivModule {}
